/* 사이트 전체 막기(9/28 사장님 「지금 사이트에서 마우스 오른쪽이라던가 집어서 옮기는 등 모두 못하게 막아 모바일에서든 웹이든 전부」).
   홈(index.html) · 무비(app/play.html) · 타로(app/tarot.html) · 처리방침 · 약관이 모두 이 파일을 부른다.
   막는 것: 오른쪽 클릭 메뉴(컴퓨터) · 길게 눌러 뜨는 메뉴(폰 — 이미지 저장 · 복사 · 공유) · 그림 · 영상 · 링크 끌어 옮기기 ·
   글자 선택 · 복사 · 잘라내기 · 저장(Ctrl/⌘+S) · 소스 보기(Ctrl/⌘+U) · 인쇄(Ctrl/⌘+P).
   입력칸(검색 · 입력)은 예전처럼 선택 · 붙여넣기가 된다. 사이트의 「이미지로 저장」 · 「공유하기」 단추는 그대로 쓴다(스크립트로 만드는 것이라 막히지 않는다). */
(() => {
  const style = document.createElement("style");
  // 10/2 — 안드로이드에서 누를 때 번쩍이던 파란 칸을 없앤다(-webkit-tap-highlight-color)
  style.textContent = `
html{-webkit-tap-highlight-color:transparent}
html,body{-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}
img,video,canvas,svg,a{-webkit-user-drag:none;-webkit-touch-callout:none}
input,textarea,select,[contenteditable="true"]{-webkit-user-select:text;user-select:text;-webkit-touch-callout:default}`;
  (document.head || document.documentElement).appendChild(style);
  for (const file of ["/app/h/accessibility-6a97188ea8.js"]) {
    const script = document.createElement("script"); script.src = file; script.defer = true;
    document.head.appendChild(script);
  }

  const typing = (t) => t instanceof Element && !!t.closest('input, textarea, select, [contenteditable="true"]');
  const stop = (e) => { if (!typing(e.target)) e.preventDefault(); };
  for (const type of ["contextmenu", "dragstart", "selectstart", "copy", "cut"]) document.addEventListener(type, stop, { capture: true });
  // 9/28 「확대 안되게 막아」는 10/8 사장님 「애플기준대로하자」(기획/130)로 풀었다 — 글자를 키워 보는 손님을 위해 두 손가락 확대 · 글자 크기 설정을 막지 않는다
  // (viewport 의 maximum-scale · user-scalable 도 모든 화면에서 뺐다).
  document.addEventListener("keydown", (e) => {
    if ((e.ctrlKey || e.metaKey) && !e.altKey && ["s", "u", "p"].includes(String(e.key).toLowerCase())) e.preventDefault();
  }, { capture: true });
})();
